import React from 'react'
import '../App.css'
import Bodyempresas from './bodyempresas'
export class Bodyappempresasbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyempresas/>
                </div>
            </div>
        );
    }
}